module.exports = __webpack_public_path__ + "media/kommissar_hm.730978d9.mp3";